import axios from "axios";
import { toast } from "sonner";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

// --- View as Producer (operator read-only impersonation) ---
const PREVIEW_KEY = "goose_preview_producer";
let _preview = null;
try { _preview = JSON.parse(localStorage.getItem(PREVIEW_KEY) || "null"); } catch { _preview = null; }

export const getPreviewProducer = () => _preview;
export const setPreviewProducerModule = (p) => {
  _preview = p;
  if (p) localStorage.setItem(PREVIEW_KEY, JSON.stringify(p));
  else localStorage.removeItem(PREVIEW_KEY);
};

const WRITE_METHODS = ["post", "put", "patch", "delete"];

// Attaches the impersonation header to every request when an operator is
// previewing a producer. The backend only honors it for operators and rejects
// any write. We also block writes client-side for an immediate read-only UX.
api.interceptors.request.use((config) => {
  // Always tell the backend our true public origin (same-origin requests omit
  // the Origin header, which otherwise leaves the backend with the internal host).
  config.headers["X-Goose-Origin"] = window.location.origin;
  if (_preview?.producer_id) {
    config.headers["X-Preview-Producer"] = _preview.producer_id;
    const method = (config.method || "get").toLowerCase();
    const url = config.url || "";
    const isProducerWrite = WRITE_METHODS.includes(method) && url.includes("/producer");
    if (isProducerWrite) {
      toast.error("Read-only preview — changes are disabled while viewing as a producer.");
      return Promise.reject(new axios.Cancel("read-only-preview"));
    }
  }
  return config;
});

export const startGoogleLogin = (path = "/producer") => {
  // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
  // `path` is the in-app entry you return to (/producer or /admin) — route and role stay separate.
  const redirectUrl = window.location.origin + path;
  window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
};
